export const stateFilters = {
    all: 'Select Status',
    open: 'Open',
    completed: 'Completed',
    ready_to_bill: 'Ready to Bill',
    trashed: 'Trashed',
};

export const timerType = {
    delivery: 'Delivery',
    application: 'Application',
}

export const deliveryType = {
    haul: 'haul',
    applyHaul: 'apply_haul',
}

export const ticketStatus = {
    mixed: 'mixed',
    completed: 'completed',
}

export const timerFields = {
    deliveryStop: 'delivery_stop',
    applicationStop: 'application_stop',
}



// WEBPACK FOOTER //
// ./src/app/tickets/constants.js